import { createSlice } from "@reduxjs/toolkit"

const initialStateFiltrosPagosSinFactura = {
  idLiquidacionWeb: -1,
  fechaVtoInicio: "",
  fechaVtoFin: "",
  fechaAltaInicio: "",
  fechaAltaFin: "",
  idJuicio: -1,
  monImporteFacDesde: "",
  monImporteFacHasta: "",
  cuitLetrado: "",
  cargados: false,
  filtroRapido: ""
};

export const filtroPagosSinFacturaSlice = createSlice({
  name: "filtroPagosSinFactura",
  initialState: initialStateFiltrosPagosSinFactura,
  reducers: {
    addFiltrosPagosSinFactura: (state, action) => {
      const { idLiquidacionWeb, fechaVtoInicio, fechaVtoFin, fechaAltaInicio, fechaAltaFin, monImporteFacDesde, monImporteFacHasta, cuitLetrado, idJuicio } = action.payload
      state.idLiquidacionWeb = idLiquidacionWeb
      state.fechaVtoInicio = fechaVtoInicio
      state.fechaVtoFin = fechaVtoFin
      state.fechaAltaInicio = fechaAltaInicio
      state.fechaAltaFin = fechaAltaFin
      state.idJuicio = idJuicio
      state.monImporteFacDesde = monImporteFacDesde
      state.monImporteFacHasta = monImporteFacHasta
      state.cuitLetrado = cuitLetrado
    },
    resetFiltrosPagosSinFactura: (state) => {
      state.idLiquidacionWeb = initialStateFiltrosPagosSinFactura.idLiquidacionWeb
      state.fechaFacturaInicio = initialStateFiltrosPagosSinFactura.fechaVtoInicio
      state.fechaFacturafin = initialStateFiltrosPagosSinFactura.fechaVtoFin
      state.fechaAltaInicio = initialStateFiltrosPagosSinFactura.fechaAltaInicio
      state.fechaAltaFin = initialStateFiltrosPagosSinFactura.fechaAltaFin
      state.monImporteFacDesde = initialStateFiltrosPagosSinFactura.monImporteFacDesde
      state.monImporteFacHasta = initialStateFiltrosPagosSinFactura.monImporteFacHasta
      state.cuitLetrado = initialStateFiltrosPagosSinFactura.cuitLetrado
      state.cargados = initialStateFiltrosPagosSinFactura.cargados
      state.filtroRapido = initialStateFiltrosPagosSinFactura.filtroRapido
      state.idJuicio = initialStateFiltrosPagosSinFactura.idJuicio
    },
    setFiltrosCargados: (state, action) => {
      state.cargados = action.payload
    },
    addFiltroRapidoPagosSinFactura: (state, action) => {
      state.filtroRapido = action.payload
    },
  }
});

export const { addFiltrosPagosSinFactura, resetFiltrosPagosSinFactura, setFiltrosCargados, addFiltroRapidoPagosSinFactura } = filtroPagosSinFacturaSlice.actions
export default filtroPagosSinFacturaSlice.reducer
